export default {
  default: 'en',
  Toolbar: {
    myRight: 'My Rights',
    consentlist: 'Consented List',
    manageConsent: 'Manage Consent',
    externalServices: 'External Services',
    general: 'General information',
    logout: 'Logout',
    admin: 'Administrator',
    usage: 'Overview',
    policy: 'Policy Form',
    consentform: 'Consent Form',
    consent: 'Consent',
    mcg: 'Group Consent Management',
    rconsent: 'Request Consent',
    email: 'Email',
    emailseting: 'System Set up',
    smtp: 'Set up SMTP Email',
    tem: 'Set up Template Email',
    petition: 'Petition',
    policyData: 'Petition Data',
    detail: 'Details',
    SearchConsent: 'Search Consent',
    cookies: 'Cookies',
    ConsentOverview: 'Usage Overview',
    announce: 'Announce',
    logosetting: 'Logo Setting',
    announceList: 'Announce List',
    bot:'ตั้งค่า Bot',
  },
  Login: {
    btnLogin: 'Login',
    TermsandConditions: 'Term and Condition',
    AccessVia: 'Login with One Platform',
    or: 'OR',
    registerOne: 'Register One Platform',
    protectionpolicy: 'Personal Data Protection Policy',
    detailEmail: 'or Sign in',
    loginEmail: 'Email (used for email services only)'
  },
  Profile: {
    userData: 'User Data',
    accountId: 'User account ID',
    username: 'Username',
    nameTh: 'Name-Last Name (Thai)',
    nameEng: 'Name-Last Name (English)',
    email: 'Email (One Platform)',
    Phone: 'Tel',
    namesurname: 'Name-Surname',
    company: 'Company Information',
    companyname: 'Company Name',
    corporateaccount: 'Corporate Account',
    corporatenumber: 'Corporate Number',
    activationdate: 'Activation Date',
    forserviceAPIs: '(For Service API)',
    SyncOneID: 'SYNC ONEID',
    editemail: 'Edit Email',
    editphone: 'Edit Tel',
    checkphone: 'Please enter Tel',
    tel10: 'Must contain at least 10 digits',
    pictext: 'Select Photo',
    pictext2: 'File to upload',
    pictext3: 'Image size should be less than 1 MB',
    fileUpload: 'Attach supporting documents',
    NoteLogo: '* The logo will be displayed on the content of the CMP system.'
  },
  consentlist: {
    Specifysearchconditions: 'Specify Search Conditions',
    allconsent: 'All Consent',
    waitConsent: 'Waiting for consent',
    ExpireConsent: 'Expire Consent',
    PetitionConsent: 'Petition Consent',
    generalconsent: 'General Consent',
    groupconsent: 'Group Consent',
    submission: 'Date Of Submission',
    rulesubmission: 'Please select a document submission date',
    rulesStatusConsent: 'Please select a status',
    to: 'To',
    ruleto: 'Please select a document submission date to',
    rulessystem: 'Please select a Source System',
    search: 'Search',
    fullconsentlist: 'Full Consent List',
    approved: 'Approved Consent',
    rejected: 'Rejected Consent',
    ActiveConsent: 'Active Consent',
    ActionConsent: 'Request submission/consent request',
    CancelConsent: 'Withdraw consent',
    list: 'List',
    copy: 'Copy',
    pic: 'Edit Photo',
    detail: 'View Detail',
    did: 'Document ID',
    Cnumber: 'Consent ID',
    type: 'Type',
    subject: 'Consent Subject',
    data: 'Requested information',
    topic: 'Policy',
    ConsentName: 'Group/Consent',
    Tag: 'requested information',
    Name: 'Name ​(OneId)',
    Tel: 'Telephone number',
    Email: 'Email',
    Idcard: 'ID card number',
    Passport: 'passport',
    organization: 'Organization',
    date: 'Date Sent',
    expiration: 'Expiration Date',
    choice: 'Choice',
    choicedetail: 'Detail',
    groupName: 'Consent Group Title',
    cancleBtn: 'Cancle',
    petitionBtn: 'Submit Request',
    active: 'Active',
    pending: 'Pending',
    inactive: 'Inactive',
    infomation: 'Personal Data',
    groupSend: 'Group',
    NameShow: 'Name provided',
    NameReq: 'Requester Name',
    DateApprove: 'Action Date',
    status1: 'In use',
    status2: 'Successfully submitted request',
    status3: 'Date when the request will be considered',
    status4: 'Request approved',
    ItemsStatus: [
      { text: 'available', value: 'active' },
      { text: 'Pending', value: 'pending' },
      { text: 'Not available', value: 'inactive' }
    ],
    ItemsStatusConsent: [
      { text: 'All', value: 'null' },
      { text: 'Active', value: 'active' },
      { text: 'Pending', value: 'pending' },
      { text: 'Deactivated', value: 'unactive' },
      { text: 'Expire', value: 'expire' },
      { text: 'A request has been submitted', value: 'action' },
      { text: 'withdraw consent', value: 'petition' }
    ],
    all: [
      { text: 'All', value: 'null' },
      { text: 'API', value: 'API' },
      { text: 'Onechat', value: 'ONECHAT' },
      { text: 'Email', value: 'EMAIL' },
      { text: 'Webscript', value: 'Webscript' },
      { text: 'Qrcode', value: 'Qrcode' }
    ],
    UserId: 'ID card number',
    groupC: 'Consent group'
  },
  dashboard: {
    total: 'Total Consent',
    all: 'All',
    issue: 'Issue',
    app: 'Approved',
    reject: 'Rejected',
    pen: 'Pending',
    generalType: 'General',
    groupType: 'Group',
    generalsub: 'General Submissions',
    groupsub: 'Group Submissions',
    list: 'List',
    permonth: 'Total consent per month',
    subject: 'Consent Subject',
    cby: 'Created by',
    use: 'Number of uses',
    detail: 'Detail',
    num: 'Number',
    name: 'Name',
    email: 'Email',
    create: 'Creation Date',
    detailtable: 'Detail',
    status: 'Status',
    statusapp: 'Approved',
    statusreject: 'Rejected',
    statuspen: 'Pending',
    gconsentdetail: 'Consent Detail',
    groupconsentdetail: 'Group Consent Detail',
    consentdetail: 'Consent Details',
    cor: 'Corporate Information',
    policy: 'Policy',
    org: 'Consent Organization',
    consentAll: 'Total consent',
    logEmail: 'Email usage data',
    count: 'Count',
    sendConsent: 'Send Consent',
    sendConsentStatus: 'Successfully sent consent',
    sendEmail: 'Send Email',
    testEmail: 'Test send email',
    alert: 'Alert',
    approved: 'Approved',
    upapproved: 'Upapproved',
    NumMonth: { text: 'All', value: 0 },
    CountMonth: [
      { text: 'All', value: 0 },
      { text: '1 Month', value: 1 },
      { text: '3 Month', value: 3 },
      { text: '6 Month', value: 6 },
      { text: '12 Month', value: 12 }
    ],
    expire: 'Expire'
  },
  policyForm: {
    crpolicy: 'Create Policy',
    allpo: 'Policy Form',
    poid: 'Policy ID',
    led: 'Date (add/edit)',
    select: 'Select',
    detail: 'Policy Detail',
    policyin: 'Policy Information',
    psps: 'Please specify policy subject',
    pspd: 'Please specify policy details',
    save: 'Save'
  },
  footer: {
    contact: 'If you encounter problems, please contact Email: nockkc@inet.co.th OR Phone. 02-026-2041',
    Privacy: 'Privacy Policy',
    notice: 'Privacy Notice'
  },
  consentform: {
    consent: 'Consent Form',
    title: 'Consent Data',
    allconsent: 'All Consent Documents',
    callconsent: 'Create Consent',
    consentid: 'Consent document ID',
    subject: 'Subject',
    add: 'Date (add/edit)',
    open: 'Open',
    off: 'Close',
    detail: 'Consent Detail',
    agree: 'Detail if you do not agree',
    organ: 'Organization',
    create: 'Creator consent form',
    age: 'Age (Year)',
    age2: 'Year',
    consentcr: 'Create Consent',
    consented: 'Edit Consent',
    speconsent: 'Specify subject consent',
    sepconsent2: 'Please enter your consent',
    exdate: 'Expiration date (Specify the number of years)',
    exdate2: 'Please enter your number of years',
    brief: 'Brief Consent Detail',
    brief2: 'Please enter your brief consent detail',
    brief3: 'Max 500 characters',
    head: 'Subject Consent :',
    pdf: 'Download PDF File',
    edit: 'Modify consent document ID (Update)',
    edit2: 'Please enter Modify consent document ID (Update)',
    close: 'Close'
  },
  mcg: {
    gcm: 'Group Consent Management',
    organgroup: 'Organization Group',
    cregroup: 'Create Group',
    row1: 'Group ID',
    row2: 'Consent Group Name',
    row3: 'Create by',
    row4: 'Date (add/edit)',
    row5: 'Select',
    add: 'Add Consent Group',
    edit: 'Edit Consent Group',
    addinfor: 'Add Group Information',
    editinfor: 'Edit Group Information',
    spegroupname: 'Specify group name',
    spegroupname2: 'Please enter your Specify group name',
    policy1: '(You can choose only 1 policy)',
    policy2: 'Select Policy',
    policy3: 'Please Select Policy',
    example: 'Example',
    consent1: '(You can choose more than one consent)',
    consent2: 'Select Consent',
    consent3: 'Please enter your consent',
    gdi: 'Group Detail Information',
    cgd: 'Consent Group Detail'
  },
  onechat: {
    step1: 'Step 1/2',
    step2: 'Step 2/2',
    set: 'Set Permissions',
    con1: 'Search Contacts',
    con2: 'Department',
    con3: 'All',
    con4: 'Employee ID',
    text1: 'Select Department',
    text2: 'Please select a department',
    text3: 'Select location',
    text4: 'Please select a location',
    consentlist: 'Consent list',
    consentlist2: 'Confirm Consent list',
    nameSur: 'Name - Surname',
    add: 'Add',
    name: 'Name-Surname',
    all1: 'All Department',
    all2: 'All Role',
    next: 'Next',
    back: 'Back',
    send: 'Send',
    send2: 'Send',
    text5: 'Choose Policy and Consent',
    text6: 'General send',
    text7: 'Group send',
    text8: 'Choose General Policy',
    text9: 'Choose General Consent',
    text10: 'Choose Group Consent',
    date: 'Transaction Date',
    status: 'Status',
    status1: 'Approve',
    status2: 'Unapprove',
    status3: 'Failed',
    status4: 'Successfully sent',
    status5: 'Open and read',
    status6: 'View more',
    status7: 'Pending',
    status8: 'Not yet sent',
    statusSendMail: 'Successfully sent',
    Note: 'Note',
    oneid: 'OnePlatform ID',
    titleNameTh: 'Thai Prefix',
    titleNameEng: 'English Prefix',
    nameTh: 'Name-Last Name (Thai)',
    nameEng: 'First-Last Name (English)',
    textGroupSend: 'Enter Group Name',
    showPolicy: 'Select Policy',
    show: 'Show',
    hide: 'Hide',
    new1: 'List from One ID',
    new2: 'List from CMP system',
    new3: 'Send Consent',
    new4: 'Submit group name',
    new6: 'Number of recipients',
    new5: 'people',
    nameSelect: 'Selected Contacts',
    editName: 'Edit List',
    statusSearch: 'Search for delivery status'
  },
  email: {
    text1: 'Email',
    text2: 'Download Template Excel',
    text3: 'Click or drag your file into this area to upload',
    text4: 'Supported files: xlsx',
    text4pdf: 'Supported files: PDF, JPG, JEPG, PNG, BMP, SVG, WEBP',
    text5: 'External Consent',
    text6: 'Delete File',
    text7: 'Confirm',
    text8: 'Name',
    text9: 'Please enter Name',
    text10: 'Email',
    text11: 'Please enter Email',
    text12: 'Clear',
    text13: 'Add Email',
    step1: 'Step 1/3',
    step2: 'Step 2/3',
    step3: 'Step 3/3',
    textTemplate: 'Choose Template Email',
    TemplateEmail: 'Template Email Name',
    SendId: 'Send Id',
    ListSend: 'Consent Send List',
    ListCheck: 'Check consent submission status',
    Note: 'Only one xlsx file can be uploaded at a time',
    Notepdf: 'Only one file can be uploaded at a time',
    Comment: ' Note : Please complete the list below. to process your consent via email',
    Commentpdf: ' Note : Please complete the list below. to upload file',
    statusSend: 'Test email sent successfully',
    itemsConsentHeader: [
      {
        Text: 'Company Name',
        Value: '{{BUSINESS-NAME}}'
      },
      {
        Text: 'Policy Number',
        Value: '{{POLICY-ID}}'
      },
      {
        Text: 'Policy Topics',
        Value: '{{POLICY-HEADER}}'
      },
      {
        Text: 'Recipient Name',
        Value: '{{NAME-TO}}'
      },
      {
        Text: 'Recipient Email',
        Value: '{{EMAIL-TO}}'
      },
      {
        Text: 'Consent Number',
        Value: '{{CONSENT-ID}}'
      },
      {
        Text: 'Consent Topic',
        Value: '{{CONSENT-HEADER}}'
      },
      {
        Text: 'Consent Group',
        Value: '{{CONSENT-GROUP}}'
      },
      {
        Text: 'Required Information',
        Value: '{{REQ-TAG}}'
      },
      {
        Text: 'Sender Name',
        Value: '{{SENDER-NAME}}'
      }
    ],
    itemsConsentDetail: [
      {
        Text: 'Company logo',
        Value: '{{LOGO}}'
      },
      {
        Text: 'Company Name',
        Value: '{{BUSINESS-NAME}}'
      },
      {
        Text: 'Policy Number',
        Value: '{{POLICY-ID}}'
      },
      {
        Text: 'Policy Topics',
        Value: '{{POLICY-HEADER}}'
      },
      {
        Text: 'Policy Description',
        Value: '{{POLICY-DETAIL}}'
      },
      {
        Text: 'Recipient Name',
        Value: '{{NAME-TO}}'
      },
      {
        Text: 'Recipient Email',
        Value: '{{EMAIL-TO}}'
      },
      {
        Text: 'Consent Number',
        Value: '{{CONSENT-ID}}'
      },
      {
        Text: 'Consent Topic',
        Value: '{{CONSENT-HEADER}}'
      },
      {
        Text: 'Consent Details',
        Value: '{{CONSENT-DETAIL}}'
      },
      {
        TextTH: 'หัวเรื่องย่อ',
        TextEN: 'Brief Consent',
        Value: '{{CONSENT-HEADER-SHORT}}'
      },
      {
        Text: 'Consent Reject',
        Value: '{{CONSENT-REJECT}}'
      },
      {
        Text: 'Consent Group',
        Value: '{{CONSENT-GROUP}}'
      },
      {
        Text: 'Required Information',
        Value: '{{REQ-TAG}}'
      },
      {
        Text: 'Sender Name',
        Value: '{{SENDER-NAME}}'
      },
      {
        Text: 'Button Consent',
        Value: '{{BUTTON-CHECK}}'
      }
    ],
    itemsConsentBtn: [
      { value: '{{ButtonCheck}}', text: 'Verify' }
    ],
    status: [
      { text: 'All', value: '' },
      { text: 'Read', value: 'Read' },
      { text: 'Success', value: 'OK' },
      { text: 'Wait', value: 'WAIT' }
    ],
    statusUpload: [
      { text: 'All', value: '' },
      { text: 'Active', value: 'active' },
      { text: 'Unactive', value: 'unactive' },
      { text: 'Expire', value: 'expire' }
    ],
    mailid: 'Email ID'
  },
  smtp: {
    text1: 'Set up SMTP Email',
    text2: 'SMTP Information',
    text3: 'Add SMTP',
    text4: 'Open',
    text5: 'Edit',
    text6: 'Delete',
    text7: 'Enable SMTP',
    text8: 'Edit SMTP',
    text9: 'You want to delete the setup SMTP email',
    text10: 'Is it right?',
    text11: 'Cancel',
    text12: 'Confirm'
  },
  template: {
    text1: 'Set up Template Email',
    text2: 'Add Template Email',
    text3: 'Set up Template Email',
    text4: 'Template Name',
    text5: 'Please enter',
    text6: 'Subject Email',
    text7: 'Style template',
    text8: 'Add Template',
    text9: 'Edit Template Email',
    text10: 'Edit Template',
    text11: 'You want to delete the setup Template Email',
    text12: 'Policy Header',
    text13: 'Uploaded Successfully',
    text14: 'Failed to upload',
    text15: 'Test Send Email',
    text16: 'Select the section you want to display',
    text17: 'Section',
    text18: 'Content',
    text19: 'Information',
    text20: 'Verify',
    text21: 'Unverified',
    text22: 'Checked',
    text23: 'Detail Template Email'
  },
  alert: {
    contactserve: 'Unable to contact serve',
    imgupload: 'Successful image upload',
    login: 'Login successfully',
    upload: 'Upload',
    success: 'Success',
    csv: 'please select .xlsx file',
    check: 'Please check file size no over 5 MB.',
    del: 'Delete file',
    confirm: 'Confirm information',
    list: 'You have successfully saved the list',
    one: 'Onechat sent successfully',
    tem: 'Edit template successfully',
    temadd: 'Add template successfully',
    upconsent: 'Update Consent Success',
    upgroup: 'Update Group Consent Success',
    uppolicy: 'Update Policy Success',
    catch: 'missing.DepartmentId not in body',
    email: 'Onechat resent successfully'
  },
  overlay: {
    load: 'Downloading data ...',
    checkRole: 'Unable to access menu'
  },
  title: {
    cmp1: 'Login | CMP'
  },
  landingpage_404: {
    title: 'Sorry, page not found',
    subTitle: 'Return to cmp.one.th'
  },
  dashboardUser: {
    sendall: 'Send All',
    generalsend: 'General',
    groupsend: 'Group',
    Totalmonth: 'Total consent per month',
    Totalconsent: 'Total Consent',
    list: 'List',
    all: 'All',
    statusapp: 'Approved',
    statusreject: 'Rejected',
    statuspen: 'Pending'
  },
  petition: {
    text1: 'Request submission',
    text2: 'Send Petition',
    text3: 'Already submitted a request',
    text4: 'Petition Sent',
    text5: 'Petition Details',
    text6: 'Organization',
    text7: 'Request Type',
    text8: 'Request Details',
    text9: 'Information To Process',
    text10: 'Detail',
    text11: 'Submit a request',
    text12: 'Created',
    text13: 'Last Edit',
    text14: 'Status',
    text15: 'Confirm',
    text16: 'Reject',
    text17: 'Waiting for review (consent sender)',
    text18: 'Number Request',
    text19: 'First Name Last Name',
    text20: 'Policy Title',
    text21: 'Consent Subject',
    text22: 'In Use / request',
    text22v2: 'In Use',
    text23: 'Deactivate',
    text24: 'Pending',
    text37: 'Expire',
    text25: 'Please clarify the reasons for requesting access to the personal data of the data subject , the document data, and evidence information for the responsible person to consider and act according to your rights.',
    text26: 'Reason for request action and reasons for the petition',
    text27: 'Request type',
    text28: 'Request data list',
    text29: 'Name',
    text30: 'Surname',
    text31: 'Phone Number',
    text32: 'Email',
    text33: 'for the following reasons',
    DocApi: 'API Documentation',
    textName: "Requester's name",
    textType: 'consent type',
    listtext: [
      { text: '1. I wish to withdraw consent' },
      { text: '2. I wish to send/transfer data abroad' },
      { text: '3. Want to access/obtain a copy' },
      { text: '4. Intention to disclose the acquisition of personal information' },
      { text: '5. Wish the personal data controller to transfer the data to another personal data controller' },
      { text: '6. I wish to obtain personal information to be sent to control other personal information' },
      { text: '7. Want to destroy data' },
      { text: '8. I wish to suspend the use of personal information' },
      { text: '9. I wish to keep the information current and complete' },
      { text: 'TEST' }
    ],
    text34: 'Please select request type.',
    text35: 'Petiton ID',
    text36: 'Petiton Topic',
    text38: 'Request awaiting response',
    text39: 'The request has been responded',
    text40: 'Date',
    text41: 'Time',
    text42: 'List of requests',
    text43: 'Please select a list of requests',
    text44: 'A request has been submitted',
    text45: 'Withdraw consent',
    all: 'All',
    approve: 'Approve',
    wait: 'Pending'
  },
  seting: {
    text1: 'Settings Menu',
    text2: 'Menu Name',
    text3: 'Create',
    text4: 'Usage',
    text5: 'Open',
    text6: 'Close'
  },
  smtpemailadd: {
    text1: 'Host format is invalid'
  },
  policy: {
    text1: 'Draft',
    text2: 'Activate',
    text3: 'Disabled',
    text4: 'Edit Policy',
    text5: 'Save Draft',
    text6: 'Save',
    text7: 'Usage Status',
    text8: 'Save a successful draft',
    text9: 'Save and activate.',
    text10: 'Save to enable'
  },
  Cookies: {
    addData: 'Registered System User',
    consent: 'Consent document',
    editData: 'Edit Domain Data',
    detail: 'Service details',
    type: 'Type',
    general: 'General',
    group: 'Group',
    Consentnumber: 'Consent number',
    Policynumber: 'Policy number',
    groupnumber: 'Group Consent Number',
    text1: 'Register a domain',
    text2: 'System information',
    text3: 'System name',
    text4: 'Domain name',
    del: 'You want to delete',
    firstStep: 'Step 1',
    copyScript: 'Copy the script below',
    addPage: 'Put the page you want to use',
    secondStep: 'Step 2',
    inputUserId: "Enter your system's USERID",
    rowInput: 'in field of',
    thirdStep: 'Step 3',
    finish: 'Finish',
    ruleUsetId: 'Please Enter User ID',
    or: 'or'
  },
  search: {
    text1: 'Download excel'
  },
  upload: {
    name: 'Name',
    tel: 'Phone Number',
    email: 'Email',
    next: 'Next',
    back: 'Back',
    upload: 'Upload Document',
    status: 'Approve / Unapprove',
    swal1: 'Are you sure?',
    swal2: 'Uploading document!',
    swal3: 'Confirm',
    swal4: 'Cancel',
    swal5: 'Please select the information correctly',
    swal6: 'Please select the correct file type.',
    swal7: 'Please enter at least 1 entry',
    swal8: 'Success!',
    swal9: 'The document has been successfully uploaded',
    text1: 'Consent Name',
    text2: 'Create By',
    text3: 'expiration date',
    text4: 'Consent detail',
    text5: 'Detail if you do not agree',
    text6: 'Close',
    text7: 'Year'
  },
  oneAccount: {
    text1: 'Upload Excel',
    text2: 'Download Template XLSX',
    text3: 'Click or drag your files into this area to upload',
    text4: 'Supported files: xls, xlsx',
    Note: 'Only one Excel file can be uploaded at a time.',
    excel: 'Please select the xls, xlsx file',
    check: 'File size not more than 5 MB',
    deleteSwal: 'You want to delete One Account ID',
    titleEdit: 'Edit One Account ID'
  },
  NewUpdate: {
    ReqDtm: 'Request request date',
    text1: 'execution date',
    text2: 'Request sent successfully',
    text3: 'System that asks for consent',
    text4: 'Passport number',
    text5: 'Please fill in the list of requested information.',
    use: 'select',
    dataRequest: 'data requesting consent',
    reason: 'reason',
    status: 'status',
    Name: 'Full Name',
    corporatenumber: '13 digit Corporate ID',
    noteDetail: 'Specify Search Conditions',
    totalPer: 'Number of recipients',
    announceId: 'Announcement number',
    announceName: 'Announcement name',
    employeecode: 'Enter employee code',
    editnamemail: 'Edit email',
    nameEng: 'Name (Eng)',
    delEmail: 'Do you want to delete email information?',
    note1: 'Note​: All domain consent data will be deleted and cannot be recovered.',
    announ1: 'Announce',
    announ2: 'Announce sending list',
    announ3: 'List for sending Announce',
    announ4: 'Announce sent successfully',
    announ5: 'Announce sent successfully',
    announ6: 'Check Announce delivery status',
    announ7: 'List of names that can send Announce',
    announ8: 'List of names that cannot send Announce',
    announ9: 'Announce Sender',
    Allname: 'All selected names',
    DetailAnn1: 'Choose Announcement Policy',
    DetailAnn2: 'Announcement name',
    DetailAnn3: 'Enter the name of the announcement',
    DetailAnn4: 'Announcement Number',
    DetailAnn5: 'Enter announcement number',
    DetailAnn6: '* Note, the number will appear below the announcement'
  },
  AnnounceList: {
    Title: 'Announcement information',
    AllData: 'All',
    WaitData: 'Wait for response',
    ErrorSendData: 'Failed to send',
    AgreeData: 'Acknowledged'
  }
}
